module.exports = __webpack_public_path__ + "img/folder-symlink-fill.e8ce470e.svg";